import * as Yup from 'yup'

type ChangePasswordFormValues = {
  password: string
  confirmPassword: string
}

export const changePasswordInitialValues: ChangePasswordFormValues = {
  password: '',
  confirmPassword: '',
}

export const changePasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Use 8 characters or more for your password')
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Password does not match')
    .required('Confirm Password is required'),
})
